import { render } from "./FormatColorFill.vue?vue&type=template&id=9903f5fa"
import script from "./FormatColorFill.vue?vue&type=script&lang=js"
export * from "./FormatColorFill.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatColorFill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9903f5fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9903f5fa', __exports__)) {
    api.reload('9903f5fa', __exports__)
  }
  
  module.hot.accept("./FormatColorFill.vue?vue&type=template&id=9903f5fa", () => {
    api.rerender('9903f5fa', render)
  })

}


export default __exports__